import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  PlayIcon,
  CurrencyDollarIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';

const Home = () => {
  const navigate = useNavigate();
  const [dbVideos, setDbVideos] = useState([]);

  const originals = [
    {
      id: 'o1',
      title: 'Anatomia dos Candlesticks',
      img: 'https://images.prismic.io/voitto-blog/ef789f64-5103-454f-adde-233553cd578c_image6.png',
      badge: 'Série Original'
    },
    {
      id: 'o2',
      title: 'Mindset Vencedor',
      img: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?q=800',
      badge: 'Exclusivo'
    },
    {
      id: 'o3',
      title: 'Ondas de Elliot',
      img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsapEeHMZEh9ePcnk7TSOCmPgzeIb9szIR3A&sw',
      badge: 'Masterclass'
    },
    {
      id: 'o4',
      title: 'Forças e Barras Elefantes',
      img: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?q=800',
      badge: 'Estratégia'
    }
  ];

  const trending = [
    { id: 't1', title: 'Position Sizing: Cálculo', img: 'https://i.ytimg.com/vi/JNwKWceRgUQ/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAuEul-J_i9k9MtpF_Y5Ui-Gjlpog' },
    { id: 't2', title: 'Kelly Criterion', img: 'https://images.unsplash.com/photo-1554224155-1696413565d3?q=800' },
    { id: 't3', title: 'Leitura de Candle', img: 'https://i.pinimg.com/564x/4d/34/38/4d3438e1b9ff4741c596f0cdc15ef679.jpg' }
  ];


  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDocs(collection(db, 'videos'));
        setDbVideos(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (e) { console.error("Firebase error:", e); }
    };
    fetch();
  }, []);

  const heroVideo = dbVideos.length > 0 ? dbVideos[0] : { title: 'Destaque TraderFlix', youtubeLink: '' };

  const getYTId = (url) => {
    if (!url) return null;
    const match = url.match(/(?:v=|\/|youtu\.be\/)([^"&?/\s]{11})/);
    return match ? match[1] : null;
  };

  const DEFAULT_IMAGE = '/hero_logo.png';

  const heroImg = getYTId(heroVideo.youtubeLink)
    ? `https://img.youtube.com/vi/${getYTId(heroVideo.youtubeLink)}/maxresdefault.jpg`
    : DEFAULT_IMAGE;

  return (
    <div className="min-h-screen bg-[#020617] text-white overflow-x-hidden font-sans">
      {/* Background Cinematográfico Fixo */}
      <div className="fixed inset-0 -z-10 bg-[#020617]">
        <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-emerald-600/10 blur-[200px] rounded-full"></div>
        <div className="absolute bottom-0 right-0 w-[40%] h-[60%] bg-blue-600/5 blur-[180px] rounded-full"></div>
      </div>

      {/* Nav */}
      <nav className="fixed top-0 left-0 w-full z-50 bg-black/90 backdrop-blur-md border-b border-white/5">
        <div className="flex justify-between items-center px-8 py-5 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-blue-600 rounded-xl flex items-center justify-center">
              <CurrencyDollarIcon className="w-6 h-6 text-white" />
            </div>
            <div className="logo-traderflix text-2xl lg:text-3xl font-black italic">
              <span>Trader</span><span className="text-emerald-500 ml-0.5">Flix</span>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/login" className="text-sm font-black text-gray-400 hover:text-white uppercase tracking-widest px-4">Login</Link>
            <Link to="/register" className="px-6 py-2.5 bg-white text-black text-sm font-black rounded-full hover:bg-emerald-500 hover:text-white transition-all uppercase">Assinar</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <header className="relative pt-48 pb-20 px-8 max-w-7xl mx-auto">
        <div className="lg:grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8 animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-[10px] font-black uppercase tracking-widest">
              <SparklesIcon className="w-4 h-4" /> Original TraderFlix
            </div>
            <h1 className="text-7xl md:text-9xl font-black tracking-tighter leading-[0.85] italic uppercase">
              TRADER <br /> <span className="text-emerald-500">FLIX</span>
            </h1>
            <p className="text-gray-400 text-lg md:text-xl max-w-xl font-medium">A plataforma de streaming para quem leva o mercado financeiro a sério.</p>
            <button onClick={() => navigate('/login')} className="px-10 py-5 bg-white text-black font-black rounded-2xl flex items-center gap-3 text-lg uppercase shadow-2xl hover:bg-emerald-500 hover:text-white transition-all">
              <PlayIcon className="w-6 h-6 fill-current" /> Começar Agora
            </button>
          </div>

          <div className="relative aspect-video rounded-[3rem] overflow-hidden border border-white/10 shadow-[0_0_80px_rgba(0,0,0,1)] bg-black group">
            <img
              src={heroImg}
              className="w-full h-full object-cover opacity-60 group-hover:opacity-100 transition-opacity"
              alt="Hero"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-xl rounded-full flex items-center justify-center border border-white/30"><PlayIcon className="w-10 h-10 ml-1" /></div>
            </div>
          </div>
        </div>
      </header>

      {/* Originais Section */}
      <section className="max-w-7xl mx-auto px-8 py-20">
        <h2 className="text-3xl font-black italic mb-10 border-l-4 border-emerald-500 pl-4 uppercase">Séries Originais</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {originals.map((v) => (
            <div key={v.id} onClick={() => navigate('/login')} className="group relative aspect-[9/14] bg-[#0d1117] rounded-[2.5rem] overflow-hidden border border-white/5 cursor-pointer hover:scale-105 transition-all duration-500">
              <img src={v.img || DEFAULT_IMAGE} className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" alt={v.title} />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
              <div className="absolute bottom-10 left-8 right-8">
                <p className="text-[10px] font-black text-emerald-500 uppercase tracking-widest mb-1">{v.badge}</p>
                <h4 className="text-xl font-black text-white leading-tight uppercase italic">{v.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Database Content Section - NOVIDADES */}
      {dbVideos.length > 0 && (
        <section className="max-w-7xl mx-auto px-8 py-20">
          <h2 className="text-3xl font-black italic mb-10 border-l-4 border-orange-500 pl-4 uppercase">Recém Adicionados</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {dbVideos.slice(1, 4).map((v) => {
              const videoThumb = getYTId(v.youtubeLink)
                ? `https://img.youtube.com/vi/${getYTId(v.youtubeLink)}/hqdefault.jpg`
                : DEFAULT_IMAGE;
              return (
                <div key={v.id} onClick={() => navigate('/login')} className="group relative aspect-video bg-[#0d1117] rounded-[2.5rem] overflow-hidden border border-white/5 cursor-pointer hover:scale-105 transition-all duration-500">
                  <img src={videoThumb} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-100 transition-opacity" alt={v.title} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
                  <div className="absolute bottom-8 left-8 right-8">
                    <p className="text-[10px] font-black text-orange-500 uppercase tracking-widest mb-1">Aula Disponível</p>
                    <h4 className="text-xl font-black text-white uppercase italic">{v.title}</h4>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      )}

      {/* Trending Section */}
      <section className="max-w-7xl mx-auto px-8 py-20 mb-20">
        <h2 className="text-3xl font-black italic mb-10 border-l-4 border-blue-500 pl-4 uppercase">Mais Assistidos</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {trending.map((v) => (
            <div key={v.id} onClick={() => navigate('/login')} className="group relative aspect-video bg-[#0d1117] rounded-[2.5rem] overflow-hidden border border-white/5 cursor-pointer hover:scale-105 transition-all duration-500">
              <img src={v.img || DEFAULT_IMAGE} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-100 transition-opacity" alt={v.title} />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
              <div className="absolute bottom-8 left-8 right-8">
                <h4 className="text-xl font-black text-white uppercase italic">{v.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </section>

      <footer className="py-20 flex flex-col items-center justify-center text-center border-t border-white/10">
        <div className="logo-traderflix text-2xl mb-4 font-black italic">
          <span>Trader</span><span className="text-emerald-500">Flix</span>
        </div>
        <p className="text-gray-600 text-[10px] md:text-xs font-black uppercase tracking-[0.3em]">© 2026 TraderFlix. Direitos Reservados.</p>
      </footer>
    </div>
  );
};

export default Home;

